import script from "./PagasPorVencimento.vue?vue&type=script&setup=true&lang=js"
export * from "./PagasPorVencimento.vue?vue&type=script&setup=true&lang=js"

import "./PagasPorVencimento.vue?vue&type=style&index=0&id=7c100977&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7c100977"]])

export default __exports__